module.exports = __webpack_public_path__ + "img/dc_header_logo.8c554332.svg";